<template>
  <v-app class="whole">
    <div class="inside">
      <v-img src="./shop.png" :height="300" ></v-img>
      <div class="btnSpace_back display_desktop">
        <v-btn color="primary" x-large text @click="goback"><span class="material-icons">
          chevron_left</span>もどる</v-btn>
      </div>
    <div class="myform">
      <div class="title-spaced">
      </div>

      <div class="titleCompany">会社概要</div>
      <div class="">
        <v-simple-table >
          <thead>
            <tr>
              <th class="text-right"></th>
              <th class="text-right"></th>
            </tr>
          </thead>
          <tbody>
            <tr >
              <td class="text-center">商号</td>
              <td class="text-left">株式会社K-51インターナショナル</td>
            </tr>
            <tr >
              <td class="text-center">サロン</td>
              <td class="text-left">〒108-0014<br>
                  東京都港区芝5丁目36-7三田ベルジュビル2F</td>
            </tr>
            <tr >
              <td class="text-center">TEL</td>
              <td class="text-left">03-5439-4951</td>
            </tr>
            <tr >
              <td class="text-center">FAX</td>
              <td class="text-left">03-5439-5194</td>
            </tr>
            <tr >
              <td class="text-center">代表者</td>
              <td class="text-left">川崎　浩一</td>
            </tr>
            <tr >
              <td class="text-center">ホームぺージ</td>
              <td class="text-left">http://www.k51-varyborn.com</td>
            </tr>
            <tr >
              <td class="text-center">事業内容</td>
              <td class="text-left">オーダーメイドスーツ・シャツ企画・販売・セミナー・企業研修・メディカル白衣製作企画・販売</td>
            </tr>
            <tr >
              <td class="text-center">メール</td>
              <td class="text-left">info@k51-varyborn.com</td>
            </tr>
            <tr >
              <td class="text-center">顧問</td>
              <td class="text-left"><b>弁護士</b><br>
                  ノースブルー総合法律事務所　國安耕太税理士<br>
                  山﨑会計事務所　山﨑憲一郎<br>
                  <b>社会保険労務士</b><br>
                  社会保険労務士事務所　木脇三博<br>
                  <b>財務(CFO)</b><br>
                    株式会社Co-creating partner　明石知樹</td>
            </tr>
          </tbody>
        </v-simple-table>
      </div>
      <div class="mapErea">
        <div class="titleCompany ">アクセスマップ</div>
        <div class="googleMap">
          <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d7156.9613794532215!2d139.74485960333564!3d35.64510640265881!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x725699112f6aa512!2sK-51INTERNATIONAL%20Co.%2CLtd!5e0!3m2!1sja!2sjp!4v1606072003136!5m2!1sja!2sjp" width="800" height="450" frameborder="0" style="border:0;" allowfullscreen="" aria-hidden="false" tabindex="0"></iframe>
        </div>
      </div>
    </div>
    </div>
  </v-app>
</template>

<script>
  export default {
    data() {
      return {
      }
    },
    computed:{
    },
    mounted() {
    },
    filters: {
    },
    methods: {
      goback() {
        this.$router.go(-1)
      },
    },
  }
</script>
<style scoped>
  .whole {
      background-color: rgba(218, 218, 219, 0.2);
      color:#555555;
    }
    .inside {
      margin: 10%;
      padding: 0 0 0% 0;
      background-color: white;
      height: 100%;
    }
    @media screen and (min-width:896px){
        .inside {
          margin: 1% 10%;
        }
      }
  .myform{
   background-color: white;
    width: 80%;
    margin: 3% auto;
  }
  @media screen and (max-width:480px){
  /*画面幅が480pxまでの時*/
    .myform{
      width: 100%;
    }
  }
  /* @media screen and (min-width:781px){ */
  @media screen and (min-width:896px){
    /*画面幅が781px以上の時*/
    .myform{
      width: 70%;
    }
  }
  
  .mtb-medium{
    margin: 5% 0%;
  }
  .mb{
    margin-bottom: 3%
  }
  .b-form-group {
    margin: 15% 0%;
    padding: 15% 0%;
  }
  .btnSpace{
    width: 50%;
    margin: 10% auto;
  }
  @media screen and (min-width:896px){
    /*画面幅が781px以上の時*/
    .btnSpace{
      width: 30%;
      margin: 15% auto;
    }
  }
  .form-spaced{
    padding: 0% 0;
  }
  .title-spaced{
    padding: 0% 0;
  }
  .alert-spaced{
    padding: 3% 0 0 0;
    /* margin: 5% 0; */
  }
  .question_spaced{
    padding: 7% 0;
  }
  .question_inside_spaced{
    padding: 4% 0;
  }
  .spinbtn-spaced{
    padding: 0 5%;
  }
  .v-btn{
    text-decoration: none;
  }
  .stepper-text {
    color:#555555;
    font-size: 0.8rem;
  }
  .stepper-text-option {
    color:white;
    font-size: 0.6rem;
    padding: 7% 0;
  }
  .tableSpace {
    margin: 1% 0 7% 0;
  }
  .spinbtn-spaced{
    width: 60%;
    padding: 0 0% 0 0 ;
  }
  .inputForm_spaced {
    margin: 5% 10% 5% 0;
    text-align: left;
    color:#555555;
  }
  .formSpace2 {
    margin: 3% 0 0 0;
  }
  .titleCompany {
    font-size: 1.5rem;
    border-left: solid 7px #3c45bd;
    padding: 0 0  0 3% ;
  }
  .btnSet2 {
    margin: 15% 0;
    text-align: center;
    padding: 0 30%;
  }
  .btnText {
    margin: 0 0 0 10%;
  }
  .formNum {
    padding: 0 5% 0 0 ;
  }
  .tableSpace_sum {
    margin: 0 0 0 60%;
  }
  .infoSpace {
    margin: 7% 0;
  }
  .totalPrice {
    font-size: 1.6rem;
    font-weight: 500;
  }
  .memoText {
    margin: 2% 5% 5% 5% ;
  }
  .googleMap {
    margin: 5% auto;
    text-align: center;
  }
  .mapErea {
    margin: 10% 0;
  }
</style>